import React from 'react';
import { Col, Row } from 'reactstrap';


const promise = () => (
	<Col sm="12" xs="12" md="12" lg="12" style={{ overflow: 'hidden' }} >


			<h2 className="text-heading-giveAssured" >The GiveIndia Promise </h2>
			<p>All nonprofits listed on the platform are cleared for legal and compliance procedures. You can be assured that we make sure that they adhere to all the requirements as laid by the law.
			</p>
			<Row>
				<Col xs="12" sm="12" md="8" lg="8">

					<img className="promise-images-mobile" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/trust_1.png" alt="Trust"/>


					<p ><b>All programs that you find listed to donate are GiveAssured</b></p>
					<p><b>‘GiveAssured’</b> is our promise to you that</p>

					<ul>
					<li><p>We ensure your donations are being channelled to the program and organization of your choice.</p></li>
					<li><p> We will bring you the most reliable giving options.</p></li>
					<li><p>All non crowdfunding programs that we list have successfully cleared an exhaustive due diligence process covering legal, financial, and implementation aspects.</p></li>
					<li><p>We will give you regular updates on the programs that you donate to</p></li>

</ul>

			

				</Col>
				<Col xs="12" sm="12" md="4" lg="4">

					<img className="promise-images" src="https://s3.ap-south-1.amazonaws.com/give-marketplace/static/images/giveassured/trust_1.png" alt="Trust"/>


				</Col>
			</Row>
			<style global jsx>
				{
					`



				@media (max-width: 768px) {
				.promise-images-mobile{
				 width: 100%;
				 padding-top: 20px;
				 padding-bottom: 20px;
			 }
				}
				@media (min-width: 769px){
					.promise-images-mobile{
					display: none;
				 }
				 }


				@media (min-width: 768px) {
				.promise-images{
				 width: 100%;
				 padding-top: 20px;
				 padding-bottom: 20px;

					}
				}
				@media (max-width: 769px) {
					.promise-images{
						display: none;
					}
				}

				`
				}
			</style>


	</Col>


);

export default promise;
